import script from "./MatchFinishView.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchFinishView.vue?vue&type=script&setup=true&lang=js"

import "./MatchFinishView.vue?vue&type=style&index=0&id=6d05eb81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d05eb81"]])

export default __exports__